import React, {useMemo, useState, useRef} from "react";
import {FaCirclePlay} from "react-icons/fa6";
import {useLoading} from "../common/LoadingContext";

const PHONETIC_ENCODINGS = {
  PHONETIC_ENCODING_IPA: "IPA",
  PHONETIC_ENCODING_UNSPECIFIED: "Unspecified",
  PHONETIC_ENCODING_X_SAMPA: "X-SAMPA",
  PHONETIC_ENCODING_JAPANESE_YOMIGANA: "Japanese Yomigana",
  PHONETIC_ENCODING_PINYIN: "Pinyin",
};

const TableRow = ({item, onEdit}) => {
  const handleEditClick = () => {
    onEdit(item);
  };

  return (
    <tr key={item.id} className="hover:bg-gray-800">
      <td
        className="border border-gray-700 px-4 py-2 cursor-pointer w-1/4"
        onClick={handleEditClick}
      >
        {item.phrase}
      </td>
      <td className="border border-gray-700 px-4 py-2 cursor-pointer w-1/4">
        <span className="flex items-center gap-2">
          <div onClick={handleEditClick} className="flex-1">
            {item.encoded_phonetic_pronunciation}
          </div>
        </span>
      </td>
      <td
        className="border border-gray-700 px-4 py-2 cursor-pointer w-1/6"
        onClick={handleEditClick}
      >
        {PHONETIC_ENCODINGS[item.phonetic_encoding] || item.phonetic_encoding}
      </td>
      <td
        className="border border-gray-700 px-4 py-2 cursor-pointer w-1/4"
        onClick={handleEditClick}
      >
        {item.simple_phonetic_pronunciation}
      </td>
      <td
        className="border border-gray-700 px-4 py-2 w-1/6 cursor-pointer"
        onClick={handleEditClick}
      >
        {item.comment}
      </td>
    </tr>
  );
};

const EditableTable = ({items, onEdit, searchParams}) => {
  const filteredSortedItems = useMemo(() => {
    if (!searchParams.searchTerm) return items;

    try {
      const lowerSearchTerm = searchParams.searchTerm.toLowerCase();
      const filteredItems = items.filter((item) => {
        try {
          if (searchParams.isRegexMode) {
            const regex = new RegExp(lowerSearchTerm, "i");
            return (
              regex.test(item.phrase) ||
              regex.test(item.encoded_phonetic_pronunciation) ||
              regex.test(item.simple_phonetic_pronunciation) ||
              regex.test(item.comment || "")
            );
          } else {
            const term = lowerSearchTerm.toLowerCase();
            return (
              item.phrase.toLowerCase().includes(term) ||
              item.encoded_phonetic_pronunciation
                .toLowerCase()
                .includes(term) ||
              item.simple_phonetic_pronunciation.toLowerCase().includes(term) ||
              (item.comment || "").toLowerCase().includes(term)
            );
          }
        } catch (e) {
          console.error("Invalid regex:", e);
          return false;
        }
      });
      const sortedItems = filteredItems.sort((a, b) =>
        a.phrase.localeCompare(b.phrase),
      );
      return sortedItems;
    } catch (error) {
      console.error("Error filtering items:", error);
      return items;
    }
  }, [items, searchParams]);

  return (
    <table className="w-full table-auto border-collapse border border-gray-700 text-white">
      <thead>
      <tr>
        <th className="border border-gray-700 px-4 py-2">Phrase</th>
        <th className="border border-gray-700 px-4 py-2">
          Encoded Phonetic Pronunciation
        </th>
        <th className="border border-gray-700 px-4 py-2">
          Phonetic Encoding
        </th>
        <th className="border border-gray-700 px-4 py-2">
          Simple Phonetic Pronunciation
        </th>
        <th className="border border-gray-700 px-4 py-2">Comment</th>
      </tr>
      </thead>
      <tbody>
      {filteredSortedItems.map((item) => (
        <TableRow
          key={item?.id}
          item={item}
          onEdit={onEdit}
        />
      ))}
      </tbody>
    </table>
  );
};

export default EditableTable;
